const ks = {
  ks1: { name: 'Schreiben', desc: 'z.B. Presseartikel, Geschichten', },
  ks2: { name: 'Vortragen', desc: 'z.B. Schauspiel, Theater', },
  ks3: { name: 'Gestalten', desc: 'z.B. Fotos, Medien', },
  ks4: { name: 'Dekorieren', desc: 'z.B. Schaufenster, Hotels', },
  ks5: { name: 'Malen', desc: 'z.B. Bilder, Zeichnungen, Gegenstände', },
  ks6: { name: 'Einrichten', desc: 'z.B. Zimmer, Wohnungen, Läden', },
  ks7: { name: 'Entwerfen', desc: 'z.B. Kleidung, Möbeldesign', },
  ks8: { name: 'Musizieren', desc: 'z.B. Instrument, Gesang', },
  ks9: { name: 'Präsentieren', desc: 'z.B. Referate, Ideen', },
  ks10: { name: 'Werken', desc: 'z.B. mit Holz, Farben, Textilien', },
}

export default ks



// WEBPACK FOOTER //
// ./src/store/ks.js